import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getMessageBoardTopic } from "../api/getMessageBoard";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

class MessageBoardTopicContainer extends React.Component {
  componentDidMount() {
    const { topicId } = this.props;
    this.props.request(topicId);
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const topic = (data && data.data) || [];
    if (loading) {
      return (
        <SkeletonTheme color="#ccc" highlightColor="#ddd">
          <Skeleton count={6} />
        </SkeletonTheme>
      );
    }
    if (!loading && Object.keys(topic).length === 0) {
      return null;
    }
    return render({ topic, loading, failure });
  };
}

MessageBoardTopicContainer.propTypes = {
  topicId: PropTypes.number.isRequired
};

export default CreateContainer(getMessageBoardTopic, MessageBoardTopicContainer);
